export default __webpack_public_path__ + "static/media/MasterCard_Logo.e69033f4.svg";